import React from 'react';
import { formatNumber } from '@/features/dashboard/utils/dashboardUtils';

interface SummaryStats {
    activeSuppliers: number;
    totalCompleted: number;
    acceptRate: number;
    slotAchievementRate: number;
}

interface DashboardSummaryCardsProps {
    stats: SummaryStats;
}

const DashboardSummaryCards: React.FC<DashboardSummaryCardsProps> = ({ stats }) => (
    <div className="summary-stats-grid">
        <div className="summary-stat-card">
            <div className="summary-stat-icon">
                <i className="fas fa-building" />
            </div>
            <div className="summary-stat-content">
                <div className="summary-stat-label">총 활성 협력사 수</div>
                <div className="summary-stat-value">{formatNumber(stats.activeSuppliers)}</div>
            </div>
        </div>
        <div className="summary-stat-card">
            <div className="summary-stat-icon">
                <i className="fas fa-check-circle" />
            </div>
            <div className="summary-stat-content">
                <div className="summary-stat-label">총 배달 완료 건수</div>
                <div className="summary-stat-value">{formatNumber(stats.totalCompleted)}</div>
            </div>
        </div>
        <div className="summary-stat-card">
            <div className="summary-stat-icon">
                <i className="fas fa-percentage" />
            </div>
            <div className="summary-stat-content">
                <div className="summary-stat-label">수락률</div>
                <div className="summary-stat-value">{stats.acceptRate.toFixed(1)}%</div>
            </div>
        </div>
        <div className="summary-stat-card">
            <div className="summary-stat-icon">
                <i className="fas fa-chart-pie" />
            </div>
            <div className="summary-stat-content">
                <div className="summary-stat-label">슬롯 달성률</div>
                <div className="summary-stat-value">{stats.slotAchievementRate.toFixed(1)}%</div>
            </div>
        </div>
    </div>
);

export default DashboardSummaryCards;
